( function () {

	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	const initializeBlock = function( $block ) {

		var block = $block[0];
		var slider = block.querySelector('.js-acf-block-hero-slider');

		if ( slider ) {
			setupSlider( slider );
		}

	};


  /**
   *
   *
   */
	const setupSlider = function( sliderElement ) {

		// Flickity settings for fade are a bit funky...
	 	// autoPlay: how long any single frame is on screen
	 	// selectedAttraction: speed of transition
		 
		var flkty = new Flickity( sliderElement, {
			cellAlign: "left",
			contain: true,
			fade: true,
			autoPlay: false,
			selectedAttraction: 0.005,
			friction: 0.1,
			pageDots: true,
			prevNextButtons: false,
			wrapAround: true
		});

	};


	/**
	 *
	 *
	 */
	if ( !document.body.classList.contains('wp-admin') ) {
		const sliders = document.querySelectorAll('.js-acf-block-hero-slider');
		sliders.forEach( element => {
			setupSlider( element );
		});
	}


	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=hero-slider', initializeBlock);
	}

} )();